import {
  GETVOUCHERREDEEMDETAILS_SUCCESS,
  GETVOUCHERREDEEMDETAILS_FAILED,
  RESET_GETVOUCHERREDEEMDETAILS,
  LOADING_GETVOUCHERREDEEMDETAILS,
  NETWORK_ERROR_GETVOUCHERREDEEMDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetVoucherRedeemDetails = () => {
  return { type: RESET_GETVOUCHERREDEEMDETAILS };
};

const getVoucherRedeemDetailsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVOUCHERREDEEMDETAILS });
    await partnerServices
      .post("getVoucherRedeemDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getVoucherRedeemDetailsSuccess(res.data));
            break;
          default:
            dispatch(getVoucherRedeemDetailsFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVOUCHERREDEEMDETAILS,
          payload: err,
        });
      });
  };
function getVoucherRedeemDetailsSuccess(data) {
  return {
    type: GETVOUCHERREDEEMDETAILS_SUCCESS,
    payload: data,
  };
}
function getVoucherRedeemDetailsFailed(data) {
  return {
    type: GETVOUCHERREDEEMDETAILS_FAILED,
    payload: data,
  };
}

export { resetGetVoucherRedeemDetails, getVoucherRedeemDetailsList };
